export function debounce<T extends (...args: any[]) => void>(cb: T, delay: number): (...args: Parameters<T>) => void {
  let timeout;

  return function (...args) {
    const wrapperFn = () => cb.apply(this, args);
    clearTimeout(timeout);
    timeout = setTimeout(wrapperFn, delay);
  };
}

export class DOMEventDispatcher {
  static dispatchGlobalEvent(element: HTMLElement, eventName: string, detail?: any): void {
    this.dispatchEvent(element, eventName, {
      detail,
      bubbles: true,
      composed: true,
    });
  }

  static dispatchLocalEvent(element: HTMLElement, eventName: string, detail?: any): void {
    this.dispatchEvent(element, eventName, { detail });
  }

  static dispatchEvent(element: HTMLElement, eventName: string, config: CustomEventInit): void {
    element.dispatchEvent(new CustomEvent(eventName, config));
  }
}
